import React from 'react';
import Card from "../../../../Utilities/Card";

/* "November 2022 - April 2026" -> "2022-2026", so the card can carry a year
   rail without anything being added to the entries above */
const rangeOf = (time = "") => {
  const years = time.match(/(19|20)\d{2}/g) || [];

  if (years.length === 0) return "";

  const first = years[0];
  const last = years[years.length - 1];

  return first === last ? first : `${first}–${last}`;
};

const Component = ({ exam, grade, time }) => {
  const range = rangeOf(time);

  return (
    <Card
      icon={range ? <span className="rail">{range}</span> : null}
      title={exam}
      meta={[grade, time].filter(Boolean).join(' · ')}
    />
  )
}

export default Component
